var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 600,
    viewBox: "0 0 700 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 600,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 402.5C247.5 374.195 270.445 351.25 298.75 351.25H350V402.5C350 430.805 327.055 453.75 298.75 453.75C270.445 453.75 247.5 430.805 247.5 402.5Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 300C350 271.696 372.945 248.75 401.25 248.75C429.554 248.75 452.5 271.695 452.5 300C452.5 328.305 429.554 351.25 401.25 351.25C372.945 351.25 350 328.304 350 300Z",
    fill: "#1ABCFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 300C247.5 328.305 270.445 351.25 298.75 351.25H350V248.75H298.75C270.445 248.75 247.5 271.695 247.5 300Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350 146.25V248.75H401.25C429.555 248.75 452.5 225.805 452.5 197.5C452.5 169.195 429.555 146.25 401.25 146.25H350Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 197.5C247.5 225.805 270.445 248.75 298.75 248.75H350V146.25H298.75C270.445 146.25 247.5 169.195 247.5 197.5Z",
    fill: "#F24E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.29eeb1416c69deef3c192ded2083c33c.svg";
export { ForwardRef as ReactComponent };